import React, { useState } from 'react'
import Mainlayout from '../layout/Mainlayout'
// import { useSelector } from 'react-redux'
import Changetheme from '../components/Changetheme'
import { VscSymbolColor, VscMenu } from "react-icons/vsc";
import { RiUserSettingsLine } from "react-icons/ri";
import ProfileChanges from '../components/ProfileChanges';


export default function Settings() {


    // const user = useSelector((state) => state.user)
    

    const [page, setPage] = useState(1)
    const [sidebar, setSidebar] = useState(true)

    


    const theme = () => {
        return (
            <Changetheme />
        )
    }
    const profilechanges = () => {
        return (
            <ProfileChanges />
        )
    }


    return (
        <Mainlayout>


            <div className='bg-dwam flex flex-row-reverse min-h-screen'>
                <div className='transition delay-150 duration-300 ease-in'>

                    {sidebar ?
                        (
                            <div className='md:w-72 h-full bg-shasham bg-opacity-70 w-fit'>
                                <div className='flex flex-row justify-between p-2 items-center text-sm text-right md:text-2xl text-yakam bg-shasham bg-opacity-80'>
                                    <div onClick={() => setSidebar(!sidebar)}><VscMenu className='w-10 h-8 text-yakam cursor-pointer hover:text-penjam' /></div>
                                    <h1 className='md:text-center'>ڕێکخستنەکان</h1>
                                </div>
                                <div className='w-full cursor-pointer '>
                                    <div onClick={() => { setPage(2) }} className='flex flex-row justify-evenly p-1 items-center text-sm md:text-lg text-yakam bg-yakam bg-opacity-5  hover:bg-opacity-10'>
                                        <RiUserSettingsLine className='w-10 h-8 text-yakam' />
                                        <button className=''>دەستکاریکردنی پرۆفایل</button>
                                    </div>
                                    <div onClick={() => { setPage(1) }} className='flex flex-row justify-evenly p-1 items-center text-sm md:text-lg text-yakam bg-yakam bg-opacity-5  hover:bg-opacity-10'>
                                        <VscSymbolColor className='w-10 h-8 text-yakam' />
                                        <button className=''>ڕوکارەکان</button>
                                    </div>
                                </div>
                            </div>
                        ) :
                        (
                            <div className=' h-full bg-shasham bg-opacity-70'>
                                <div className='flex flex-row justify-between p-2 items-center text-sm text-right md:text-2xl text-yakam bg-shasham bg-opacity-80'>
                                    <div onClick={() => setSidebar(!sidebar)}><VscMenu className='w-10 h-8 text-yakam cursor-pointer hover:text-penjam' /></div>

                                </div>
                                <div className='w-full cursor-pointer '>
                                    <div onClick={() => { setPage(2) }} className='flex flex-row justify-evenly p-1 items-center text-sm md:text-lg text-yakam bg-yakam bg-opacity-5  hover:bg-opacity-10'>
                                        <RiUserSettingsLine className='w-10 h-8 text-yakam' />

                                    </div>
                                    <div onClick={() => { setPage(1) }} className='flex flex-row justify-evenly p-1 items-center text-sm md:text-lg text-yakam bg-yakam bg-opacity-5  hover:bg-opacity-10'>
                                        <VscSymbolColor className='w-10 h-8 text-yakam' />

                                    </div>
                                </div>
                            </div>
                        )
                    }
                </div>
                <div className='w-full '>

                {
                    page === 1 ?
                        (
                            theme()

                        ) :
                    page=== 2 ?
                        (
                            profilechanges()
                        ) :
                        (
                            null
                        )
                }
                </div>
            </div>

        </Mainlayout>
    )
}




